import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { InputSelect, setTitleCase } from "app/components/template/partials";
import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { setSchedule } from "utils/action";
import { AESDecryptURL } from "utils/encryption/AESDecrypt";
import * as Yup from "yup";

// REDUX
import { getCustomers } from "app/redux/dropdown";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

// inital values form
const initialValues = {
  customer: null,
};

// form field validation schema
const validationSchema = Yup.object().shape({
  customer: Yup.object().nullable().required("Pelanggan wajib diisi!"),
});

export function SettingSchedule() {
  const { dropdownCustomersData } = useSelector(
    (state) => ({
      dropdownCustomersData: state.DropdownCustomersData,
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const showDialog = location.state?.showDialog ?? false;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const secureID = AESDecryptURL(id);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getCustomers());
  }, [dispatch]);

  const onHide = () => {
    navigate(-1);
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const request = {
      id: parseInt(secureID),
      id_pelanggan: values.customer?.id,
      tersedia: false,
    };

    // send to backend
    try {
      await setSchedule(request);
      toast.success(setTitleCase("berhasil memilih jadwal"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-create-customer-title"
    >
      <DialogTitle id="responsive-dialog-create-customer-title">
        Pengaturan Jadwal
      </DialogTitle>
      <Divider />
      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ handleSubmit, values, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputSelect}
                    options={dropdownCustomersData?.data ?? []}
                    isLoading={dropdownCustomersData?.isLoading}
                    getOptionLabel={(option) => option?.nama_pelanggan ?? ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    name="customer"
                    label="Pelanggan"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <LoadingButton
                autoFocus
                loading={isLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Simpan
              </LoadingButton>
              <Button
                autoFocus
                onClick={onHide}
                color="error"
                variant="contained"
              >
                Kembali
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
